// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import HoleIllustration from '@/assets/images/hole.png';
import WaterIcon from '@/assets/images/water.png';
import BunkerIcon from '@/assets/images/bunker.png';
import PenaltyIcon from '@/assets/images/penalties.png';
import ThreePuttIcon from '@/assets/images/threeputt.png';
import MysteryPrizeIcon from '@/assets/images/mystery.png';
import GolfballIcon from '@/assets/images/golfball.png';
import BirdieImage from '@/assets/images/birdie.png';
import BestBallSelectImage from '@/assets/images/games/best-ball-select.png';
import BunkerSelectImage from '@/assets/images/games/bunker-select.png';
import HighLowSelectImage from '@/assets/images/games/high-low-select.png';
import MysterySelectImage from '@/assets/images/games/mystery-select.png';
import SkinsSelectImage from '@/assets/images/games/skins-select.png';
import StablefordSelectImage from '@/assets/images/games/stableford-select.png';
import WaterSelectImage from '@/assets/images/games/water-select.png';
import WorstBallSelectImage from '@/assets/images/games/worst-ball-select.png';
import ScoreButtonImage from '@/assets/images/button-score.png';
import ScoreButtonSelectedImage from '@/assets/images/button-score-clicked.png';
import TrophyImage from '@/assets/images/trophy.png';
import TrophyOnlyImage from '@/assets/images/trophy_only.png';
import PuttButtonImage from '@/assets/images/button-putt.png';

const GAME_ICON_MAP: Record<string, number> = {
  'best-ball': BestBallSelectImage,
  bunker: BunkerSelectImage,
  'high-low': HighLowSelectImage,
  mystery: MysterySelectImage,
  skins: SkinsSelectImage,
  stableford: StablefordSelectImage,
  water: WaterSelectImage,
  'worst-ball': WorstBallSelectImage,
};

export {
  BirdieImage,
  BestBallSelectImage,
  BunkerIcon,
  BunkerSelectImage,
  GAME_ICON_MAP,
  GolfballIcon,
  HighLowSelectImage,
  HoleIllustration,
  MysteryPrizeIcon,
  MysterySelectImage,
  PenaltyIcon,
  PuttButtonImage,
  ScoreButtonImage,
  ScoreButtonSelectedImage,
  SkinsSelectImage,
  StablefordSelectImage,
  ThreePuttIcon,
  TrophyImage,
  TrophyOnlyImage,
  WaterIcon,
  WaterSelectImage,
  WorstBallSelectImage,
};
